export default "__VITE_ASSET__C_66GYHX__"